import React from 'react';
import brand from '../config/brand';

// Subtle "Powered by COMPASS" product attribution for the main website footer.
//
// Reads from the central brand config so it can be hidden or re-pointed per
// conference deployment without touching this component. When no product URL is
// configured yet it renders as plain text (no dead link).
const PoweredByCompass = ({ style = {} }) => {
  const { name, tagline, url, showAttribution } = brand.product;
  if (!showAttribution) return null;

  const label = (
    <>
      Powered by <strong style={{ fontWeight: 700, letterSpacing: '0.3px' }}>{name}</strong>
    </>
  );

  const content = url ? (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      title={tagline}
      style={{ color: 'inherit', textDecoration: 'none' }}
    >
      {label}
    </a>
  ) : (
    <span title={tagline}>{label}</span>
  );

  return (
    <div
      className="powered-by-compass"
      style={{ fontSize: 12, color: '#98A2B3', textAlign: 'center', ...style }}
    >
      {content}
    </div>
  );
};

export default PoweredByCompass;
